/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 削除フラグ
 * @export
 * @interface DeleteFlg
 */
export interface DeleteFlg {
}

/**
 * Check if a given object implements the DeleteFlg interface.
 */
export function instanceOfDeleteFlg(value: object): value is DeleteFlg {
    return true;
}

export function DeleteFlgFromJSON(json: any): DeleteFlg {
    return DeleteFlgFromJSONTyped(json, false);
}

export function DeleteFlgFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFlg {
    return json;
}

export function DeleteFlgToJSON(json: any): DeleteFlg {
    return DeleteFlgToJSONTyped(json, false);
}

export function DeleteFlgToJSONTyped(value?: DeleteFlg | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

